import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

import imgStepOne from "../images/IMG_0782.jpg";
import imgStepTwo from "../images/IMG_4306.jpg";
import imgStepThree from "../images/IMG_7614.jpg";
import imgStepFour from "../images/IMG_1448.jpg";
import imgStepFive from "../images/IMG_0398.jpg";

const process = [
  {
    step: "1. Inquiry & Introduction",
    desc: "If you are intrigued to know more about my photography offerings, feel free to reach out via email at ck.pxgallery@gmail.com. We’ll schedule a 30-minute call to get better acquainted. I am more than happy to walk you through my photography styles, experience, and approach. Meanwhile, I’m equally eager to hear your stories, and learn about your plans and wishes, so we can align expectations nicely.",
    img: imgStepOne,
  },
  {
    step: "2. Offer & Agreement",
    desc: "After the introduction, I will prepare an offer for you, including the service details, pricing, and any additional information you might need. Take your time reviewing it and discussing any questions or adjustments with me. When we’re both satisfied and the deposit is settled, the agreement is made.",
    img: imgStepTwo,
  },
  {
    step: "3. Walking through details",
    desc: "As time unfolds, the intricate details begin to take shape. It's time to discuss essential aspects such as schedule, locations, outfits, venue decoration, guest list, etc. together at least 2-4 weeks before the big day, ensuring that we are meticulously prepared for the magical moment.",
    img: imgStepThree,
  },
  {
    step: "4. Photoshoot",
    desc: "Finally, the day has come, the day when love, joy, and celebration converge. As you immerse yourself in the festivities, surrounded by cherished family and friends, I’ll be there, stealthily weaving through the crowd, capturing those fleeting moments that deserve to be etched into eternity. After the photo shooting day, I will share at least 10 sneak preview photos with you within a week.",
    img: imgStepFour,
  },
  {
    step: "5. Delivery",
    desc: "Depending on the type of photography session, you can expect to receive your digital photos within 6 to 10 weeks. Each image is meticulously edited, capturing the essence of your special moments. In the meantime, I will be very much appreciated to receive any feedback from you.",
    img: imgStepFive,
  },
];

export default function Process() {
  const theme = useTheme();

  const styledBox = (step, desc, imgURL, flip) => {
    const imgBox = (
      <Box display={{ xs: "none", md: "flex" }} width={"25%"}>
        <img
          style={{
            width: "100%",
          }}
          src={imgURL}
          alt={step}
        ></img>
      </Box>
    );

    return (
      <Box
        display={"flex"}
        flexDirection={"row"}
        padding={theme.spacing(2)}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {!flip && imgBox}
        <Box
          display={"flex"}
          flexDirection={"column"}
          width={{ md: "55%", xs: "100%" }}
          pl={flip ? 0 : { md: theme.spacing(5), xs: theme.spacing(0) }}
          pr={flip ? { md: theme.spacing(5), xs: theme.spacing(0) } : 0}
        >
          <Typography variant="h5" fontFamily={"Commuter Sans Regular"}>
            {step}
          </Typography>
          <p>{desc}</p>
        </Box>
        {flip && imgBox}
      </Box>
    );
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      padding={{ md: theme.spacing(7), xs: theme.spacing(2) }}
      alignItems={"center"}
      pl={{ md: theme.spacing(20), xs: theme.spacing(5) }}
      pr={{ md: theme.spacing(20), xs: theme.spacing(5) }}
      sx={{
        fontSize: { xs: "0.8rem", md: "0.9rem" },
      }}
    >
      <Typography variant="h3" fontStyle="italic" pb={theme.spacing(4)}>
        How to get started?
      </Typography>
      {styledBox(process[0].step, process[0].desc, process[0].img)}
      {styledBox(process[1].step, process[1].desc, process[1].img, true)}
      {styledBox(process[2].step, process[2].desc, process[2].img)}
      {styledBox(process[3].step, process[3].desc, process[3].img, true)}
      {styledBox(process[4].step, process[4].desc, process[4].img)}
    </Box>
  );
}
